(function() {
  'use strict';
  function OpenStreetMap(els) {
    this.maps = els;
    var self = this;
    if (!document.getElementById('leaflet')) {
      //var style = document.createElement('link');
      //style.type = 'text/css';
      //style.href = '/typo3conf/ext/lns_sitepackage/Resources/Public/JavaScript/Vendor/leaflet/leaflet.css';
      //style.rel = 'stylesheet';
      //document.head.appendChild(style);
      var script = document.createElement('script');
      script.id = 'leaflet';
      script.src = '/typo3conf/ext/lns_sitepackage/Resources/Private/JavaScript/Vendor/leaflet/leaflet.js';
      script.addEventListener('load', function() {
        self.init();
      });
      document.head.appendChild(script);
    }
  }
  OpenStreetMap.prototype = {
    createMap: function (map, lat, lon, zoom) {
      // initialize map
      this.map = L.map(map).setView([lat, lon], zoom);
      // set map tiles source
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
        maxZoom: 18,
      }).addTo(this.map);
    },
    setMarker: function (lat, lon, title, street, place) {
      if (this.map) {
        // add marker to the map
        var marker = L.marker([lat, lon]).addTo(this.map);
        // add popup to the marker
        marker.bindPopup("<strong>" + title + "</strong><br />" + street + '<br />' + place);
      }
    },
    init: function () {
      var self = this;
      for (var i=0; i < this.maps.length; i++) {
        var lat = this.maps[i].getAttribute('data-lat'),
            lon = this.maps[i].getAttribute('data-lon');
        if (lat && lon) {
          this.createMap(this.maps[i], lat, lon, 16);
        }
        var marker = this.maps[i].querySelectorAll("[data-type='marker']");
        for (var m=0; m < marker.length; m++) {
          var m_lat = marker[m].getAttribute('data-lat'),
              m_lon = marker[m].getAttribute('data-lon'),
              m_title = marker[m].getAttribute('data-title'),
              m_street = marker[m].getAttribute('data-street'),
              m_place = marker[m].getAttribute('data-place');
          if (m_lat && m_lon) {
            this.setMarker(m_lat, m_lon, m_title, m_street, m_place);
          }
        }
      }
    }
  };

  // get all divs on page that are of type OpenStreetMap
  var els = document.querySelectorAll("[data-type='OpenStreetMap']");
  if (els.length > 0) {
    new OpenStreetMap(els);
  }
})();
